module.exports = __webpack_public_path__ + "static/scale-model-of-dark-hour-haunted-house-in-richardson-texas-f9a6e2e6c896a1777b9e404c4131ce2c.png";